/**
 * Helpers for pulling real files out of a drag or paste payload.
 *
 * New Outlook (the WebView2 one) does not put an actual file into the drag payload — an attachment
 * dragged from it arrives with an empty `files` list and only metadata formats, so the drop looks
 * like it worked while nothing lands in the app. Everything here funnels through `filesFrom*` so a
 * payload without files can be detected once and reported to the user instead of silently ignored.
 */

const filesFromItems = (items: DataTransferItemList | null): File[] => {
  if (!items) return [];
  return Array.from(items)
    .filter(item => item.kind === 'file')
    .map(item => item.getAsFile())
    .filter(file => file !== null);
};

export const filesFromDataTransfer = (dataTransfer: DataTransfer | null): File[] => {
  if (!dataTransfer) return [];
  if (dataTransfer.files?.length > 0) return Array.from(dataTransfer.files);
  // Some sources expose the payload only through `items`; `files` stays empty there.
  return filesFromItems(dataTransfer.items);
};

export const filesFromClipboard = (clipboardData: DataTransfer | null): File[] => filesFromDataTransfer(clipboardData);